import React from "react";
import gif1 from "../../../images/icon/original-66948a0d81d.gif";
import featureIcon1 from "../../../images/icon/feature-icon01.svg";
import featureIcon2 from "../../../images/icon/feature-icon02.svg";
import aboutBg from "../../../images/bg/about-bg02.png";


const AboutSection: React.FC = () => {
  return (
    <section className="about pos-rel pb-140">

      <div className="container">
        {/* ===== Title Section ===== */}
        <div className="sec-title sec-title-center about-sec-title about-sec-title-two mt-45">
          <span className="sub-title mb-10">Who We are?</span>

          <h2 className="title">
            We help
            <span><img src={gif1} alt="gif" /></span>
            grow businesses
          </h2>
          <h3>We are a multidisciplinary engineering startup built on experience, not hype.</h3>
          <p className="content">
Although newly established as a company, our team brings a rich portfolio of delivered projects across software engineering, cloud infrastructure, and mechanical engineering. We combine digital intelligence with physical engineering to help businesses design, build, optimize, and scale real-world solutions.
          </p>
        </div>

        {/* ===== Feature Boxes ===== */}
        <div className="row mt-40">
          {/* 1 */}
          <div className="col-lg-6 col-md-6 mt-30">
            <div className="xb-feature-item">

              <div className="xb-item--inner xb-border mh600">
                <span className="xb-item--icon">
                  <img src={featureIcon1} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h1 className="mt-20">Mechanical Engineering</h1>
                  <p className="xb-item--content">
                  We provide practical, performance-driven mechanical engineering services for industrial environments.
Our mechanical team focuses on efficiency, accuracy, and manufacturability, helping clients turn ideas into production-ready solutions.
Our expertise includes:
                  </p>

                  <ul className="xb-item--content pl-20 mt-10">
                    <li>Product concept design and mechanical modeling</li>
                    <li>Engineering drawings and technical documentation</li>
                    <li>Industrial optimization and process improvement</li>
                    <li>Digital manufacturing workflows</li>
                    <li>CAD/CAE solutions tailored to production needs</li>
                </ul>

                <p className="xb-item--content mt-10">
                  Every design decision is grounded in real-world constraints and operational performance.
                </p>

                </div>
              </div>
            </div>
          </div>

          {/* 2 */}
          <div className="col-lg-6 col-md-6 mt-30">
            <div className="xb-feature-item">
              <div className="xb-item--inner xb-border mh600">
                <span className="xb-item--icon">
                  <img src={featureIcon2} alt="icon" />
                </span>
                <div className="xb-item--holder">
                  <h1 className="mt-20">Software Engineering</h1>
                  <p className="xb-item--content ">
                  We design, build, and operate modern software systems that are scalable, secure, and production-ready.
From startups to industrial clients, we help teams move fast without sacrificing reliability.
                  </p>


                <ul className="xb-item--content pl-20 mt-10">
                    <li>Custom web and mobile application development</li>
                    <li>Cloud architecture & infrastructure (GCP)</li>
                    <li>DevOps, CI/CD automation, and system reliability</li>
                    <li>API design, backend systems, and integrations</li>
                    <li>Scalable dashboards and multi-tenant platforms</li>
                </ul>

                <p className="xb-item--content mt-10">
                  Every design decision is grounded in real-world constraints and operational performance.
                </p>


                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* Background */}
      <div className="about-bg">
        <img src={aboutBg} alt="background" />
      </div>
    </section>
  );
};

export default AboutSection;
